import { NotificationData, notifications } from '@mantine/notifications';
import classes from './Notifications.module.css';
import { IconCheck, IconInfoCircle, IconX } from '@tabler/icons-react';

interface NotificationProps {
  type: 'Error' | 'Default' | 'Info' | 'Success';
  title: string;
  message?: string;
  loading?: boolean;
  autoClose?: boolean;
}

export const showNotification = ({
  type = 'Default',
  title,
  message,
  loading = false,
  autoClose = true
}: NotificationProps) => {
  if (type === 'Error') {
    return notifications.show({
      color: 'red',
      title: title,
      message: message,
      classNames: classes,
      icon: !loading && <IconX />,
      loading,
      autoClose: autoClose
    });
  } else if (type === 'Info') {
    return notifications.show({
      color: 'blue',
      title: title,
      message: message,
      classNames: classes,
      icon: !loading && <IconInfoCircle />,
      loading,
      autoClose: autoClose
    });
  } else if (type === 'Success') { //TMP SUCCESS SIMILAR TO DEFAULT
    return notifications.show({
      color: 'green',
      title: title,
      message: message,
      classNames: classes,
      icon: !loading && <IconCheck />,
      loading,
      autoClose: autoClose
    });
  } else { //TODO: CHANGE DEFAULT NOTIFICATION STYLE
    return notifications.show({
      color: 'green',
      title: title,
      message: message,
      classNames: classes,
      icon: !loading && <IconCheck />,
      loading,
      autoClose: autoClose
    });
  }
};

export const updateNotification = ({ id, ...rest }: NotificationData) => {
  notifications.update({
    id,
    ...rest
  });
};
